import { __ } from '@wordpress/i18n';

const reportBlocks = Array.from(
	document.querySelectorAll('.block-report-content[data-report-resource-url]')
);

const getResourceUrl = (reportBlock) => {
	try {
		const resourceUrl = new URL(
			reportBlock.dataset.reportResourceUrl,
			window.location.href
		);

		if (!['http:', 'https:'].includes(resourceUrl.protocol)) {
			return '';
		}

		return resourceUrl.href;
	} catch {
		return '';
	}
};

const revealResource = (reportBlock, formFrame) => {
	if (reportBlock.dataset.reportResourceState === 'unlocked') {
		return;
	}

	const resourceUrl = getResourceUrl(reportBlock);

	if (!resourceUrl || !formFrame || !reportBlock.contains(formFrame)) {
		return;
	}

	const resource = document.createElement('div');
	const title = document.createElement('h3');
	const copy = document.createElement('p');
	const link = document.createElement('a');

	resource.classList.add('block-report-content__resource');
	resource.setAttribute('aria-live', 'polite');
	resource.setAttribute('role', 'status');
	resource.setAttribute('tabindex', '-1');

	title.classList.add('block-report-content__resource-title');
	title.textContent = __('Thank you. Your report is ready.', 'propel');

	copy.classList.add('block-report-content__resource-copy');
	copy.textContent = __('Use the link below to access your copy.', 'propel');

	link.classList.add(
		'block-report-content__resource-link',
		'c-btn',
		'c-btn--primary'
	);
	link.href = resourceUrl;
	link.textContent = __('Access the report', 'propel');

	resource.append(title, copy, link);
	formFrame.insertAdjacentElement('afterend', resource);

	reportBlock.dataset.reportResourceState = 'unlocked';
	resource.focus();
};

const getFormMatch = (formId) => {
	const normalizedFormId = formId.toLowerCase();
	const formFrames = Array.from(
		document.querySelectorAll('.hs-form-frame[data-form-id]')
	).filter(
		(formFrame) =>
			formFrame.dataset.formId?.toLowerCase() === normalizedFormId
	);

	if (formFrames.length !== 1) {
		return null;
	}

	const formFrame = formFrames[0];
	const reportBlock = formFrame.closest(
		'.block-report-content[data-report-resource-url]'
	);

	if (
		!reportBlock ||
		!reportBlocks.includes(reportBlock) ||
		!formFrame.closest('.block-report-content__sidebar')
	) {
		return null;
	}

	return { formFrame, reportBlock };
};

const handleHubSpotV4Success = (event) => {
	const formId = event.detail?.formId;

	if (!formId || typeof formId !== 'string') {
		return;
	}

	const match = getFormMatch(formId);

	if (!match) {
		return;
	}

	revealResource(match.reportBlock, match.formFrame);
};

if (reportBlocks.length > 0) {
	window.addEventListener(
		'hs-form-event:on-submission:success',
		handleHubSpotV4Success
	);
}
